
export function courseRouteUrl(router, course) {
    /** force the base to be /cursus because the url sent in the CourseJsonResource starts with /cursus */
    return course.url.replace(router.options.base.replace(/^\/[^/]+/, '/cursus'), '');
}
